import { ordersTypes } from "../types";

const initState = {
  orderDetails: null,
  orderDetailsLoading: false,

  filesLoading: 0,
  ordersList: [],
  ordersChildsList: {},
  ordersListLoading: true,

  subscriptionsDetails: [],
  subscriptionsDetailsLoading: false,

  chargeUSPTOFeeLoading: false,
  feeRechargeLoading: false,

  requestLoading: 0,
  error: null,
};

export function orders(state = initState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ordersTypes.GET_ORDERS_REQUEST: {
      return { ...state, ordersListLoading: true };
    }
    case ordersTypes.GET_ORDERS_SUCCESS: {
      const ordersChildsList = {};

      payload.forEach((mainOrder) => {
        ordersChildsList[mainOrder?.uid] = payload?.filter((order) => order?.parentOrderUid === mainOrder?.uid) || [];
      });

      return { ...state, ordersListLoading: false, ordersList: payload, ordersChildsList };
    }
    case ordersTypes.GET_ORDERS_FAILURE: {
      return { ...state, ordersListLoading: false, ordersList: [] };
    }

    case ordersTypes.GET_ORDER_REQUEST: {
      return { ...state, orderDetailsLoading: true, orderDetails: null };
    }
    case ordersTypes.GET_ORDER_SUCCESS: {
      return { ...state, orderDetailsLoading: false, orderDetails: payload };
    }
    case ordersTypes.GET_ORDER_FAILURE: {
      return { ...state, orderDetailsLoading: false, orderDetails: null, error };
    }

    case ordersTypes.GET_ORDER_CLEAR_ERROR: {
      return { ...state, error: null };
    }

    case ordersTypes.PUT_PRODUCT_REQUEST: {
      return { ...state, orderDetailsLoading: true, requestLoading: state.requestLoading + 1 };
    }
    case ordersTypes.PUT_PRODUCT_SUCCESS: {
      return { ...state, orderDetailsLoading: false, orderDetails: payload, requestLoading: state.requestLoading - 1 };
    }
    case ordersTypes.PUT_PRODUCT_FAILURE: {
      return { ...state, orderDetailsLoading: false, requestLoading: state.requestLoading - 1 };
    }

    case ordersTypes.POST_ORDER_SPECIMEN_REQUEST: {
      return { ...state, orderDetailsLoading: true, requestLoading: state.requestLoading + 1 };
    }
    case ordersTypes.POST_ORDER_SPECIMEN_SUCCESS: {
      return { ...state, orderDetailsLoading: false, orderDetails: payload, requestLoading: state.requestLoading - 1 };
    }
    case ordersTypes.POST_ORDER_SPECIMEN_FAILURE: {
      return { ...state, orderDetailsLoading: false, requestLoading: state.requestLoading - 1 };
    }

    case ordersTypes.GET_ORDER_FILE_REQUEST: {
      return { ...state, filesLoading: state.filesLoading + 1 };
    }
    case ordersTypes.GET_ORDER_FILE_SUCCESS: {
      return { ...state, filesLoading: state.filesLoading - 1 };
    }
    case ordersTypes.GET_ORDER_FILE_FAILURE: {
      return { ...state, filesLoading: state.filesLoading - 1 };
    }

    case ordersTypes.CUSTOMER_ACTION_REQUEST: {
      return { ...state, orderDetailsLoading: true };
    }
    case ordersTypes.CUSTOMER_ACTION_SUCCESS: {
      return { ...state, orderDetailsLoading: false, orderDetails: payload };
    }
    case ordersTypes.CUSTOMER_ACTION_FAILURE: {
      return { ...state, orderDetailsLoading: false };
    }

    case ordersTypes.POST_ORDER_SPECIMEN_WITHOUT_REFRESH_REQUEST: {
      return { ...state, requestLoading: state.requestLoading + 1 };
    }
    case ordersTypes.POST_ORDER_SPECIMEN_WITHOUT_REFRESH_SUCCESS: {
      return { ...state, requestLoading: state.requestLoading - 1 };
    }
    case ordersTypes.POST_ORDER_SPECIMEN_WITHOUT_REFRESH_FAILURE: {
      return { ...state, requestLoading: state.requestLoading - 1 };
    }

    case ordersTypes.PUT_PRODUCT_WITHOUT_REFRESH_REQUEST: {
      return { ...state, requestLoading: state.requestLoading + 1 };
    }
    case ordersTypes.PUT_PRODUCT_WITHOUT_REFRESH_SUCCESS: {
      return { ...state, requestLoading: state.requestLoading - 1 };
    }
    case ordersTypes.PUT_PRODUCT_WITHOUT_REFRESH_FAILURE: {
      return { ...state, requestLoading: state.requestLoading - 1 };
    }

    // SUBSCRIPTIONS DETAILS
    case ordersTypes.GET_SUBSCRIPTIONS_DETAILS_REQUEST: {
      return { ...state, subscriptionsDetailsLoading: true };
    }
    case ordersTypes.GET_SUBSCRIPTIONS_DETAILS_SUCCESS: {
      return { ...state, subscriptionsDetailsLoading: false, subscriptionsDetails: payload };
    }
    case ordersTypes.GET_SUBSCRIPTIONS_DETAILS_FAILURE: {
      return { ...state, subscriptionsDetailsLoading: false };
    }

    case ordersTypes.CHARGE_USPTO_FEE_REQUEST: {
      return { ...state, chargeUSPTOFeeLoading: true };
    }
    case ordersTypes.CHARGE_USPTO_FEE_SUCCESS: {
      return { ...state, chargeUSPTOFeeLoading: false, orderDetails: payload };
    }
    case ordersTypes.CHARGE_USPTO_FEE_FAILURE: {
      return { ...state, chargeUSPTOFeeLoading: false };
    }

    case ordersTypes.FEE_RECHARGE_REQUEST: {
      return { ...state, feeRechargeLoading: true };
    }
    case ordersTypes.FEE_RECHARGE_SUCCESS: {
      return { ...state, feeRechargeLoading: false, orderDetails: payload };
    }
    case ordersTypes.FEE_RECHARGE_FAILURE: {
      return { ...state, feeRechargeLoading: false };
    }

    default:
      return state;
  }
}
